import { Compania } from '../index';

export class ImportarCategoriaDTO {
    //PK
    categoriaId: Number;

    //Atributos
    codigo : string;
    nombre : string;

    //Relaciones
    compania : Compania;

    //validaciones
    categoriaValida: boolean;
    codigoValido: boolean;
    nombreValido: boolean;

    //Otras Variables
    styleClass: string;

    //mensajes de error
    mensajeErrorCodigo: string;
    mensajeErrorNombre: string;

    //Constructor
    constructor(){};

    //Metodos Color de Celda
    get getColorCeldaCodigo() : string{
        if(this.mensajeErrorCodigo!='')
            return "red-bg";
        else return "";
    }
    get getColorCeldaNombre() : string{
        if(this.mensajeErrorNombre!='')
            return "red-bg";
        else return "";
    }

    //Metodos Mensaje de Error
    get getMensajeErrorCodigo(): string{
        if(this.mensajeErrorCodigo!='')
            return this.mensajeErrorCodigo;
        else return "";
    }
    get getMensajeErrorNombre(): string{
        if(this.mensajeErrorNombre!='')
            return this.mensajeErrorNombre;
        else return "";
    }

    //Otros
    clone(): any {
        var cloneObj = new (this.constructor());
        for (var attribut in this) {
            if (typeof this[attribut] === "object") {
                cloneObj[attribut] = this.clone();
            } else {
                cloneObj[attribut] = this[attribut];
            }
        }
        return cloneObj;
    }

    copiar(objeto : any){
        //Propios
        this.categoriaId = objeto.categoriaId;
        this.codigo = objeto.codigo;
        this.nombre = objeto.nombre;
        this.mensajeErrorCodigo = objeto.mensajeErrorCodigo;
        this.mensajeErrorNombre = objeto.mensajeErrorNombre;
        this.categoriaValida = objeto.categoriaValida;

        //Relaciones
        if(objeto.compania != null){
            this.compania = new Compania();
            this.compania.copiar(objeto.compania);
        }
    }
}